import { Link } from 'react-router-dom';
import { HrmDualToneTitle } from '../hrm/HrmDualToneTitle';
import { useLocalizedPath } from '@/lib/i18n/useLocale';
import img1 from '@/assets/Customer feedback3.png';
import img2 from '@/assets/Customer feedback4.png';

export function CrmManagement({
    title,
    description,
    icon,
    id,
}: {
    title: string;
    description: string;
    icon?: string;
    id?: string;
}) {
    const localizedPath = useLocalizedPath();

    const content = (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14 items-center cursor-pointer">
            <div className="lg:col-span-2 col-span-1 flex flex-col justify-center lg:order-1 order-2">
                <HrmDualToneTitle title={title} />
                <p className="mt-6 text-primary-text/90 font-medium sm:text-base text-[15px] lg:text-[20px] leading-relaxed pl-6 ml-auto">
                    {description}
                </p>
            </div>

            {/* Illustration */}
            <div className="flex justify-center lg:justify-start lg:order-2 order-1 motion-safe:animate-float">
                {/* {icon === 'recruitment' ? <Recruitment /> : <BusinessDeal />} */}
                <img src={icon === 'recruitment' ? img1 : img2} alt={title} className="w-full h-full object-contain" />
            </div>
        </div>
    );

    return (
        <section className="my-[20px] shadow-sm rounded-lg p-4">
            {id ? <Link to={localizedPath(`/crm/${id}`)}>{content}</Link> : content}
        </section>
    );
}
